<div
  class="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-6 my-8 border border-gray-200"
  *ngIf="!showPaymentOptions"
>
  <h2 class="text-2xl font-bold text-gray-800 text-center mb-6">
    Checkout Order
  </h2>

  <div class="relative mb-4 w-full" *ngFor="let address of userAddress">
    <!-- <span class="absolute right-4 top-1/2 box-content block h-3 w-3 -translate-y-1/2 "></span>  -->
    <label
      class="flex cursor-pointer flex-col rounded-2xl border border-purple-700 bg-white p-4 pr-8 sm:pr-16"
      *ngIf="address?.isDefault === true"
    >
      <div class="lg:flex justify-between overflow-hidden">
        <span class="text-xl font-semibold">
          <p>{{ address?.addressType }}</p>
          <b>{{ address?.delivery_name }} </b> ({{ address?.delivery_mobile }})
          <br />
          <p class="text-lg text-purple-700">
            {{ address?.delivery_address }},{{ address?.delivery_city }},{{
              address?.delivery_pincode
            }},{{ address?.delivery_state }},{{ address?.delivery_country }}
          </p>
        </span>
        <button
          class="bg-purple-500 lg:m-4 w-auto dark:bg-gray-600 text-white py-2 px-8 rounded-lg font-bold dark:hover:bg-gray-700 shadow-lg"
          (click)="openDialog()"
        >
          Change Address
        </button>
      </div>
    </label>
  </div>

  <!-- Product and Summary Section -->
  <div class="grid gap-6 md:grid-cols-3">
    <!-- Product Details Card -->
    <!-- Product Details (Left Side) -->
    <div
      class="md:col-span-2 bg-white rounded-lg min-h-48 h-auto shadow-md border border-purple-500 flex flex-col sm:flex-row gap-4 sm:gap-6 p-4 items-start"
    >
      <!-- Product Image -->
      <div class="w-24 sm:w-40 flex-shrink-0 flex justify-center">
        <img
          [src]="getDisplayImage()"
          alt="Product Image"
          class="h-24 sm:h-36 w-full object-contain rounded-lg"
        />
      </div>

      <!-- Product Information -->
      <div class="flex flex-col flex-1 min-w-0 w-full">
        <h4 class="text-lg font-semibold line-clamp-2">
          {{ productDetailss?.productDetails?.productName }}
        </h4>

        <!-- Description -->
        <p class="text-gray-600 text-sm mb-2 line-clamp-2">
          {{ productDetailss?.productDetails?.productDescription }}
        </p>

        <!-- Price -->
        <p class="text-gray-700 font-medium mb-2">Price: ₹{{ displayPrice }}</p>

        <div class="flex">
          <!-- Size -->
          <p class="text-sm mb-1 mr-3" *ngIf="selectedSize">
            <strong>Size:</strong> {{ selectedSize }}
          </p>

          <!-- Color -->
          <div class="flex items-center gap-2 text-sm mb-3">
            <strong>Color:</strong>

            <span
              class="w-4 h-4 rounded-full border border-gray-300"
              [style.background-color]="
                varinatColor || productDetailss?.productColor
              "
            ></span>

            <span>
              {{ varinatColor || productDetailss?.productColor }}
            </span>
          </div>
        </div>
        <!-- Quantity Controller -->
        <div class="flex w-full items-center">
          <div class="flex w-fit max-w-full border border-purple-700 rounded-lg overflow-hidden">
            <!-- Minus -->
            <button
              class="flex h-10 w-10 shrink-0 items-center justify-center border-r border-purple-700 hover:bg-purple-50"
              (click)="decreaseQuantity()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path fill="currentColor" d="M19 12.998H5v-2h14z" />
              </svg>
            </button>

            <!-- Quantity -->
            <span class="flex min-w-12 items-center justify-center px-3 py-1 font-semibold text-center">
              {{ quantity }}
            </span>

            <!-- Plus -->
            <button
              class="flex h-10 w-10 shrink-0 items-center justify-center border-l border-purple-700 hover:bg-purple-50"
              (click)="increaseQuantity()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Coupon & Summary Section (Right Side) -->
    <div class="flex flex-col gap-6">
      <!-- Coupon Code Section -->
      <div class="bg-gray-100 p-6 rounded-lg shadow-lg">
        <h1 class="text-xl font-semibold mb-4">Apply Coupon Code</h1>
        <div class="mb-4">
          <label for="coupon" class="block text-gray-700 font-semibold mb-2"
            >Coupon Code:</label
          >
          <input
            type="text"
            id="coupon"
            name="coupon"
            [(ngModel)]="couponCode"
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 uppercase"
            placeholder="Enter coupon code"
          />
        </div>
        <div class="text-center">
          <button
            class="btncolor text-white px-4 py-2 rounded-lg bg-purple-600 focus:ring focus:ring-purple-500"
            (click)="applyCoupon()"
          >
            Apply Coupon
          </button>
        </div>
        <div
          [ngClass]="{
            'text-purple-500': isCouponApplied,
            'text-red-500': !isCouponApplied,
          }"
          class="mt-4 text-sm text-center"
        >
          {{ message }}
        </div>
      </div>

      <!-- Order Summary Section -->
      <div class="bg-white rounded-lg shadow-md p-6">
        <h2 class="text-lg font-semibold mb-4">Summary</h2>
        <div class="flex justify-between mb-2">
          <span>Subtotal</span>
          <span>₹{{ subTotal || 0 }}</span>
          <!-- <span>₹{{ subTotal || 0 }}</span> -->
        </div>
        <!-- <div class="flex justify-between mb-2">
          <span>Coupon</span>
          <span>₹{{ discountPrice || 0 }}</span>
        </div> -->
        <div class="flex justify-between mb-2">
          <span>Shipping</span>
          <span
            *ngIf="
              productDetailss?.priceInventoryShippingInfo?.shippingCharge;
              else freeShipping
            "
          >
            ₹{{ shippingCharge }}
          </span>
          <ng-template #freeShipping>
            <span class="text-blueviolet">Free</span>
          </ng-template>
        </div>
        <hr class="my-2" />
        <div class="flex justify-between mb-2 font-semibold">
          <span>Total</span>
          <!-- Show discounted price if a coupon is applied or if online payment is selected -->
          <span *ngIf="isCouponApplied"> ₹{{ subTotal.toFixed(2) }} </span>

          <!-- <span *ngIf="isCouponApplied">
  ₹{{ (subTotal - 35).toFixed(2) }}
</span> -->

          <!-- Show normal price if no coupon is applied and COD is selected -->
          <span *ngIf="!isCouponApplied"> ₹{{ subTotal.toFixed(2) }} </span>
        </div>
        <button
          class="bg-purple-600 text-white font-bold text-xl py-2 px-4 rounded-lg mt-4 w-full"
          (click)="openPaymentOptions()"
        >
          Payment method
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showPaymentOptions">
  <!-- <app-payment-option
    (paymentMethodSelected)="onSourceButtonClick($event)"
    (selectPaymentOption)="selectPaymentOption($event)"
    [payments1]="payments1"
    [orderIdCashFree]="orderIdCashFree"
    [totalAmount]="isCouponApplied ? subTotal : subTotal"
    [isProcessing]="isProcessing"
    [sessionId]="sessionId"
    [orderId]="cashFreeOrderId"
    (codSelected)="onCodSelected()"
    (paymentSuccess)="onPaymentSuccess($event)"
  >
  </app-payment-option> -->
  <app-payment-option
    (paymentMethodSelected)="onSourceButtonClick($event)"
    (selectPaymentOption)="selectPaymentOption($event)"
    [payments1]="payments1"
    [orderIdCashFree]="orderIdCashFree"
    [totalAmount]="subTotal"
    [mrpAmount]="mrpTotal"
    [couponDiscount]="isCouponApplied ? discountPrice : 0"
    [isProcessing]="isProcessing"
    [sessionId]="sessionId"
    [orderId]="cashFreeOrderId"
    (codSelected)="onCodSelected()"
    (paymentSuccess)="onPaymentSuccess($event)"
    (goBack)="showPaymentOptions = false"
  >
  </app-payment-option>
</div>
